module.exports = __webpack_public_path__ + "img/empty_employee.74fdf308.png";